import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import ButtonOutline from './ButtonOutline.vue'
import { useI18n } from 'vue-i18n'

interface EMITS {
  (e: 'createPoi', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonCreatePoi',
  emits: ["createPoi"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const emits = __emit
const active = ref(false)

function handleClick() {
  active.value = !active.value
  emits('createPoi', active.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonOutline, {
    class: _normalizeClass(["create-poi", {
      'create-poi__active': active.value
    }]),
    iconLeft: require('@/assets/icons-general/icon-poi-small.svg'),
    buttonText: _unref(t)('general__data__create'),
    size: "medium-icon",
    onOnClicked: handleClick
  }, null, 8, ["class", "iconLeft", "buttonText"]))
}
}

})